import type { AnalyticsManager } from "services/analytics/analyticsManager";

export const loadLibPhoneNumber = async (analyticsManager: AnalyticsManager): Promise<void> => {
  await new Promise<void>((resolve, reject) => {
    // Check if script is already loaded
    if (document.querySelector('script[src*="libphonenumber-mobile.js"]')) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://storage.googleapis.com/anna-ws-prod/anna-web-auth/libphonenumber-mobile.js";
    script.async = true;

    // Add timeout to prevent indefinite loading
    const timeoutId = setTimeout(() => {
      script.remove();
      analyticsManager.event("libphonenumber-timeout");
      reject(
        new Error("Phone validation library failed to load. Please check your internet connection and try again."),
      );
    }, 15000); // 15 second timeout

    script.onload = () => {
      clearTimeout(timeoutId);
      resolve();
    };

    script.onerror = () => {
      clearTimeout(timeoutId);
      script.remove();
      analyticsManager.event("libphonenumber-error");
      reject(
        new Error("Phone validation library failed to load. Please check your internet connection and try again."),
      );
    };

    document.head.appendChild(script);
  });
};
